module.exports = __webpack_public_path__ + "static/media/colicoli28.86bbc731.webp";